import React from "react";
import { Link } from "react-router-dom";
import { Compass, ArrowLeft } from "lucide-react";
import { API_BASE } from "@/lib/api";

const TITLES = { privacy: "Privacy Policy", terms: "Terms of Service", support: "Support" };

const LegalPage = ({ page }) => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="h-16 border-b border-border flex items-center justify-between px-4 sm:px-6 bg-card">
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-full bg-primary flex items-center justify-center">
            <Compass className="w-5 h-5 text-primary-foreground" />
          </div>
          <span className="font-heading text-lg font-semibold">{TITLES[page] || "Legal"}</span>
        </div>
        <Link to="/auth" data-testid="legal-back" className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground">
          <ArrowLeft className="w-4 h-4" /> Back
        </Link>
      </header>
      <iframe
        data-testid={`legal-frame-${page}`}
        title={TITLES[page]}
        src={`${API_BASE}/api/legal/${page}`}
        className="flex-1 w-full bg-white"
      />
    </div>
  );
};

export default LegalPage;
